"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.frequencyToSchedule = exports.scheduleToFrequency = void 0;
var mobx_react_1 = require("mobx-react");
var QuoteSectionStore_1 = require("QuoteV2/Stores/QuoteSectionStore");
var react_1 = __importDefault(require("react"));
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var inversify_react_1 = require("inversify-react");
var QuoteComponents_1 = require("./QuoteComponents");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var QuoteViewStore_1 = require("QuoteV2/Stores/QuoteViewStore");
var Recurrence_1 = require("@CommonFrontendBackend/QuoteV2/Recurrence");
var mobx_1 = require("mobx");
var classnames_1 = __importDefault(require("classnames"));
var DiscountPill_1 = __importDefault(require("./DiscountPill"));
var react_transition_group_1 = require("react-transition-group");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var QuoteItemStore_1 = require("QuoteV2/Stores/QuoteItemStore");
var lodash_1 = require("lodash");
var utils_1 = require("@qwilr/kaleidoscope/utils");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var c = (0, BemBuilder_1.default)("plan-group");
var scheduleToFrequency = function (schedule) {
    return (0, Types_1.isRecurringSchedule)(schedule) ? schedule.frequency : "one off";
};
exports.scheduleToFrequency = scheduleToFrequency;
var frequencyToSchedule = function (frequency) {
    if (Object.values(Types_1.RecurringFrequency).includes(frequency)) {
        return { type: Types_1.BillingScheduleType.Recurring, frequency: frequency };
    }
    return { type: Types_1.BillingScheduleType.OneOff };
};
exports.frequencyToSchedule = frequencyToSchedule;
var groupToTabValue = function (group) { return ((0, QuoteSectionStore_1.isBillingScheduleGroup)(group) ? (0, exports.scheduleToFrequency)(group) : group); };
var tabValueToGroup = function (value) {
    return value === QuoteSectionStore_1.PRODUCT_TOKEN_GROUP ? QuoteSectionStore_1.PRODUCT_TOKEN_GROUP : (0, exports.frequencyToSchedule)(value);
};
var PlanGroupTabs = (function (_super) {
    __extends(PlanGroupTabs, _super);
    function PlanGroupTabs() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _this.containerRef = react_1.default.createRef();
        _this.buildPortalClasses = function () {
            var wrapper = _this.containerRef.current;
            if (wrapper) {
                var clientBlockDiv = wrapper.closest("[data-id]");
                if (clientBlockDiv) {
                    return "project-block--id-".concat(clientBlockDiv.getAttribute("data-id"));
                }
                var publicBlockDiv = wrapper.closest("[class*='project-block--id']");
                if (publicBlockDiv) {
                    return Array.from(publicBlockDiv.classList)
                        .filter(function (c) { return c.startsWith("project-block--id"); })
                        .join(" ");
                }
            }
            return "";
        };
        _this.changeSelectedTab = function (group) {
            var onChangeGroup = _this.props.onChangeGroup;
            onChangeGroup(group);
        };
        return _this;
    }
    PlanGroupTabs.prototype.componentDidMount = function () {
        this.portalClasses = this.buildPortalClasses();
    };
    PlanGroupTabs.prototype.groupLabel = function (group) {
        if ((0, QuoteSectionStore_1.isProductTokenGroup)(group)) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(icons_1.Tokens, null),
                "Products"));
        }
        var freq = (0, exports.scheduleToFrequency)(group);
        if (freq === "one off") {
            return this.quoteViewStore.getLabel(Types_1.QuoteLabel.OneOffAdjective);
        }
        return this.quoteViewStore.getLabel((0, Recurrence_1.mapRecurringFrequencyToAdjectiveLabel)(freq));
    };
    Object.defineProperty(PlanGroupTabs.prototype, "tabCount", {
        get: function () {
            var section = this.props.section;
            return section.groups.length;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PlanGroupTabs.prototype, "useDropdownOnMobile", {
        get: function () {
            return this.tabCount >= 3;
        },
        enumerable: false,
        configurable: true
    });
    PlanGroupTabs.prototype.render = function () {
        var _a;
        var _this = this;
        var _b = this.props, section = _b.section, selectedGroup = _b.selectedGroup, getGroupDiscount = _b.getGroupDiscount;
        var selectedGroupDiscount = getGroupDiscount(selectedGroup);
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("container"), (_a = {},
                _a["".concat(c("container", "invisible"))] = this.tabCount === 1 && this.quoteViewStore.hideMode === QuoteViewStore_1.QuoteHideMode.Invisible,
                _a[c("", "use-dropdown-on-mobile")] = this.useDropdownOnMobile,
                _a)), ref: this.containerRef },
            react_1.default.createElement("div", { className: (0, classnames_1.default)("user-font", c("tab-group")) },
                react_1.default.createElement(kaleidoscope_1.SegmentedControl, { labelHidden: true, label: "billing frequency", size: kaleidoscope_1.SegmentedControlSize.Large, selectedValue: groupToTabValue(selectedGroup), options: section.groups.map(function (group) {
                        var _a;
                        var groupDiscount = getGroupDiscount(group);
                        var selectedItems = section.itemsByGroup(group).filter(function (item) {
                            if (item instanceof QuoteItemStore_1.QuotePricedItemStore) {
                                return item.isOptional && item.isOptionalSelected;
                            }
                        });
                        var showSelectIndicator = selectedItems.length >= 1 && !(0, lodash_1.isEqual)(group, selectedGroup);
                        return {
                            label: (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("tab"), (_a = {}, _a[c("tab", "token")] = (0, QuoteSectionStore_1.isProductTokenGroup)(group), _a)) },
                                _this.groupLabel(group),
                                react_1.default.createElement(react_transition_group_1.Transition, { mountOnEnter: true, unmountOnExit: true, timeout: kaleidoscope_2.AnimationDuration.Medium, onEnter: utils_1.forceReflow, in: showSelectIndicator }, function (status) { return (react_1.default.createElement("div", { className: (0, classnames_1.default)(c("frequency-indicator-wrapper"), c("frequency-indicator-wrapper", status)) },
                                    react_1.default.createElement(kaleidoscope_1.Tooltip, { content: "".concat(selectedItems.length, " selected") },
                                        react_1.default.createElement("div", { className: (0, classnames_1.default)(c("frequency-indicator"), c("frequency-indicator", status)) })))); }),
                                !!groupDiscount && react_1.default.createElement(DiscountPill_1.default, { discount: groupDiscount, showSavedDiscountName: false }),
                                _this.quoteComponents.PlanSectionEditGroupMenu && (0, QuoteSectionStore_1.isBillingScheduleGroup)(group) && (react_1.default.createElement(_this.quoteComponents.PlanSectionEditGroupMenu, { section: section, group: group, onChangeGroup: function (schedule) { return _this.changeSelectedTab(schedule); }, groupDiscount: groupDiscount !== null && groupDiscount !== void 0 ? groupDiscount : undefined })))),
                            value: groupToTabValue(group),
                        };
                    }), onClickHandler: function (value) {
                        var group = tabValueToGroup(value);
                        _this.changeSelectedTab(group);
                    } })),
            react_1.default.createElement("div", { className: (0, classnames_1.default)("user-font", c("mobile-dropdown")) },
                react_1.default.createElement(kaleidoscope_1.OptionMenu, { button: react_1.default.createElement(kaleidoscope_1.Button, { size: kaleidoscope_1.ButtonSize.Large, type: kaleidoscope_1.ButtonType.Secondary, decorator: kaleidoscope_1.ButtonDecorator.Dropdown },
                        this.groupLabel(selectedGroup),
                        !!selectedGroupDiscount && (react_1.default.createElement(DiscountPill_1.default, { discount: selectedGroupDiscount, showSavedDiscountName: false }))), className: (0, classnames_1.default)("portal", this.portalClasses), size: "large" }, section.groups.map(function (group) {
                    var groupDiscount = getGroupDiscount(group);
                    return (react_1.default.createElement(kaleidoscope_1.OptionMenuItem, { key: groupToTabValue(group), selected: groupToTabValue(group) === groupToTabValue(selectedGroup), onClick: function () { return _this.changeSelectedTab(group); } },
                        react_1.default.createElement("div", { className: (0, classnames_1.default)("user-font", c("dropdown-label")) },
                            _this.groupLabel(group),
                            !!groupDiscount && react_1.default.createElement(DiscountPill_1.default, { discount: groupDiscount, showSavedDiscountName: false }))));
                }))),
            this.quoteComponents.PlanSectionAddGroupMenu && (react_1.default.createElement(this.quoteComponents.PlanSectionAddGroupMenu, { section: section, onAddGroup: function (schedule) { return _this.changeSelectedTab(schedule); } }))));
    };
    var _a, _b;
    __decorate([
        (0, inversify_react_1.resolve)(QuoteComponents_1.QuoteComponents.$),
        __metadata("design:type", typeof (_a = typeof QuoteComponents_1.QuoteComponents !== "undefined" && QuoteComponents_1.QuoteComponents) === "function" ? _a : Object)
    ], PlanGroupTabs.prototype, "quoteComponents", void 0);
    __decorate([
        (0, inversify_react_1.resolve)(QuoteViewStore_1.QuoteViewStore.$),
        __metadata("design:type", typeof (_b = typeof QuoteViewStore_1.QuoteViewStore !== "undefined" && QuoteViewStore_1.QuoteViewStore) === "function" ? _b : Object)
    ], PlanGroupTabs.prototype, "quoteViewStore", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], PlanGroupTabs.prototype, "portalClasses", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Number),
        __metadata("design:paramtypes", [])
    ], PlanGroupTabs.prototype, "tabCount", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], PlanGroupTabs.prototype, "useDropdownOnMobile", null);
    PlanGroupTabs = __decorate([
        mobx_react_1.observer
    ], PlanGroupTabs);
    return PlanGroupTabs;
}(react_1.default.Component));
exports.default = PlanGroupTabs;
